"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const isInstanceOfCustomError = (err) => {
    return Object.keys(err).includes("error_code");
};
const isInstanceOfFormError = (err) => {
    return Object.keys(err).includes("errors");
};
/**
 *
 * handleError will normalize different type of errors into a single structure
 *
 * @param { APIError } error
 * @returns { SerializedError[] } returns a normalized object of error response
 */
const handleError = (error) => {
    const errorResponseBody = error.errors;
    const serializedErrors = [];
    let isPushed = false;
    if (isInstanceOfCustomError(errorResponseBody)) {
        serializedErrors.push(Object.assign({ message: errorResponseBody.error_code, errorType: errorResponseBody.error_type }, (errorResponseBody.parameters && {
            parameters: errorResponseBody.parameters,
        })));
        isPushed = true;
    }
    if (isInstanceOfFormError(errorResponseBody) && !isPushed) {
        serializedErrors.push({
            message: "validationError",
            errorType: "validation_error",
        });
        isPushed = true;
    }
    if (!(Object.keys(errorResponseBody).length === 0) && !isPushed) {
        switch (error.statusCode) {
            case 404:
                serializedErrors.push({
                    message: "notFound",
                    errorType: "notFound",
                });
                break;
            case 401:
                serializedErrors.push({
                    message: "unauthorized",
                    errorType: "unauthorized",
                });
                break;
            case 403:
                serializedErrors.push({
                    message: "unauthorized",
                    errorType: "unauthorized",
                });
                break;
            case 400:
                serializedErrors.push({
                    message: "validationFailed",
                    errorType: "validationFailed",
                });
                break;
            case 500:
                serializedErrors.push({
                    message: "internalServerError",
                    errorType: "internalServerError",
                });
                break;
            case 503:
                serializedErrors.push({
                    message: "serviceUnavailable",
                    errorType: "serviceUnavailable",
                });
                break;
        }
    }
    return serializedErrors;
};
exports.handleError = handleError;
